import { Component, AfterViewInit, ElementRef ,OnInit, ViewChild, HostListener} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: "app-index",
  templateUrl: "./index.component.html",
})
export class IndexComponent implements OnInit {
  ngOnInit(): void {
    
  }
  
}
